import { useLayoutEffect, useState } from "react";
import { useWindowSize } from "usehooks-ts";
export const useOptionContainerPos = (ref, width, height, xOffset, yOffset = 0, basePos = { x: 0, y: 0 }) => {
    const windowSize = useWindowSize();
    const [pos, setPos] = useState({
        x: basePos.x + xOffset,
        y: basePos.y + yOffset,
    });
    useLayoutEffect(() => {
        if (ref.current?.parent && windowSize.width > 0 && windowSize.height > 0) {
            const _pos = ref.current.parent.getGlobalPosition();
            const yOverflow = Math.max(0, _pos.y + height + 1 - windowSize.height);
            if (_pos.x + basePos.x + xOffset + width + 2 > windowSize.width) {
                setPos({ x: basePos.x - (width + 1), y: basePos.y - yOverflow });
            }
            else {
                setPos({
                    x: basePos.x + xOffset,
                    y: basePos.y + yOffset - yOverflow,
                });
            }
        }
    }, [windowSize.width, windowSize.height, xOffset, yOffset, ref, width, height, basePos.x, basePos.y]);
    return pos;
};
//# sourceMappingURL=useOptionContainerPos.js.map